export const MAINTENANCE_MODE_CODE = 'MAINTENANCE_MODE';

interface ApiError {
  status?: unknown;
  data?: unknown;
}

export function isMaintenanceModeResponse(
  status: unknown,
  data: unknown
): boolean {
  return (
    status === 503 &&
    typeof data === 'object' &&
    data !== null &&
    'code' in data &&
    data.code === MAINTENANCE_MODE_CODE
  );
}

export function isMaintenanceModeError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;

  const { status, data } = error as ApiError;
  return isMaintenanceModeResponse(status, data);
}
